export const environment = {
  mdermUrl: 'https://qa.nxthealth.us/mderm',
  mindcapUrl: 'https://qa.nxthealth.us/mindcap',
  permissionsUrl: 'https://qa.nxthealth.us/permissions',
  vestibularUrl: 'https://qa.nxthealth.us/vestaidsb',
  keycloak: {
    authUrl: 'https://qaauth.nxthealth.us/',
  },
};
